import React from "react";
import { CheckLicense } from "../License/CheckLicense";
import { Button, MenuButton, MenuItemProps, MenuShorthandKinds, MoreIcon, ShorthandCollection } from "@fluentui/react-northstar";

type Props = {
    items: ShorthandCollection<MenuItemProps, MenuShorthandKinds>
}

export const TableAction: React.FC<Props> = ({ items }) => {
    return (
        <div className='flex items-center flex-row-reverse pr-7'>
            <CheckLicense disable>
            <MenuButton
                trigger={
                    <Button icon={<MoreIcon />} text iconOnly title="Actions" onClick={(e) => {
                        e.stopPropagation();
                    }} />
                }
                menu={{
                items: items,
                }}
            />
            </CheckLicense>
        </div>
    )
}